import React, { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Toolbar from '@mui/material/Toolbar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { theme } from './Theme';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Typography } from '@mui/material';
import { ThemeProvider } from '@emotion/react';

const styles = {
  toolbarMargin: {
    ...theme.mixins.toolbar,
    // marginBottom: '3em',
    [theme.breakpoints.down('md')]: {
      marginBottom: '2em',
    },
    [theme.breakpoints.down('xs')]: {
      marginBottom: '1.25em',
    },
  },
  logo: {
    height: '8em',
    [theme.breakpoints.down('md')]: {
      height: '7em',
    },
    [theme.breakpoints.down('xs')]: {
      height: '5.5em',
    },
  },
  logoContainer: {
    padding: 0,
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#FFFFFF'
    },
  },
  tabs: {
    marginLeft: 'auto',
    '& .MuiButtonBase-root.MuiTab-root': {
      fontSize: 20,
    },
    '& .Mui-selected': {
      // backgroundColor: '#126ede',
      color: '#ffffff',
      opacity: 0.5,
      borderRadius: 0,
    },
  },
  tab: {
    ...theme.typography.tab,
    minWidth: 10,
    marginLeft: '25px',
    color: 'white',
  },

  hamburgerMenuIcon: {
    height: '30px',
    width: '30px',
  },
  menuIconContainer: {
    marginLeft: 'auto',
    color: 'white',
    '&:hover': {
      opacity: 1,
    },
  },
  appbar: {
    zIndex: theme.zIndex.modal + 1,
    marginBottom: 7
  },
};

const DesktopNavigation = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <Tabs
      value={value}
      onChange={handleChange}
      aria-label="nav tabs example"
      sx={styles.tabs}
    >
      {
        localStorage.getItem("user") &&
        <Tab sx={styles.tab} label="Ovládací panel" component={Link} to="/adminhome" />
      }
      <Tab sx={styles.tab} label="Domov" component={Link} to="/" />
      <Tab sx={styles.tab} label="O nás" component={Link} to="/about" />
      <Tab sx={styles.tab} label="Prihlásenie" component={Link} to="/login" />
    </Tabs>
  );
};

const MobileNavigation = () => {
  const [openDrawer, setOpenDrawer] = React.useState(false);

  const iOS =
    typeof navigator !== 'undefined' &&
    /iPad|iPhone|iPod/.test(navigator.userAgent);

  return (
    <React.Fragment>
      <SwipeableDrawer
        disableBackdropTransition={!iOS}
        disableDiscovery={iOS}
        anchor='right'
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        onOpen={() => setOpenDrawer(true)}
      >
        <Box sx={styles.toolbarMargin} />
        <Paper>
          <List disablePadding>

            {localStorage.getItem("user") &&
              <ListItem
              divider
              button
              component={Link}
              to="/adminhome"
              onClick={() => setOpenDrawer(false)}
              >
                <ListItemText disableTypography>Ovládací panel</ListItemText>
              </ListItem>
            
            }


            <ListItem
              divider
              button
              component={Link}
              to="/"
              onClick={() => setOpenDrawer(false)}
            >
              <ListItemText disableTypography>Domov</ListItemText>
            </ListItem>
            <ListItem
              divider
              button
              component={Link}
              to="/about"
              onClick={() => setOpenDrawer(false)}
            >
              <ListItemText disableTypography>O nás</ListItemText>
            </ListItem>
            <ListItem
              divider
              button
              component={Link}
              to="/login"
              onClick={() => setOpenDrawer(false)}
            >
              <ListItemText disableTypography>Prihlásenie</ListItemText>
            </ListItem>
          </List>
        </Paper>
      </SwipeableDrawer>
      <IconButton
        sx={styles.menuIconContainer}
        onClick={() => setOpenDrawer(!openDrawer)}
        disableRipple
      >
        <MenuIcon sx={styles.hamburgerMenuIcon} />
      </IconButton>
    </React.Fragment>
  );
};

const Navbar = () => {
  const isMobileMode = useMediaQuery(theme.breakpoints.down('sm'));

  return (
      <Box sx={{ flexGrow: 1 , marginBottom: 10  }}>
      <Fragment>
        <AppBar
          position="fixed"
          sx={styles.appbar}
          color="primary"
          elevation={9}
        >
          <Toolbar disableGutters={true} sx={{alignItems: 'center', paddingLeft: '23%', justifyContent: 'center'}}>
          <ThemeProvider theme={theme}>
              <Typography variant='subtitle1'>Ľudová hudba Ryfoldzani</Typography>
            {isMobileMode ? <MobileNavigation /> : <DesktopNavigation />}
          </ThemeProvider>
          </Toolbar>
        </AppBar>
      </Fragment>
      </Box>
  );
};

export default Navbar;
